import { images } from "../constants";

const testimonials = [  
    { 
        id: 1,
        image: images.testimonial1, 
        name: 'Ethan Walker', 
        title: 'Business Owner',
        content: 'The taxi service provided by TaxiPro was exceptional. The drivers were punctual, professional, and made my trips smooth and comfortable. Highly recommend their services!'
    }, 
    { 
        id: 2,
        image: images.testimonial2, 
        name: 'Emma Harris', 
        title: 'Frequent Traveler',
        content: 'TaxiPro consistently provides reliable and efficient service. I use them for all my airport transfers and local travel. Their attention to detail and customer care are top-notch.'
    },
    { 
        id: 3,
        image: images.testimonial3, 
        name: 'Lucas Johnson', 
        title: 'Tourist',
        content: 'My experience with TaxiPro was fantastic. The drivers were friendly, knowledgeable about the area, and made sure I reached my destination on time. Great service overall!'
    },    
    { 
        id: 4,
        image: images.testimonial4, 
        name: 'Sophia Brooks', 
        title: 'Local Resident',
        content: 'TaxiPro\'s service is second to none. I appreciate their promptness and the comfort of their vehicles. It\'s my go-to taxi service for all my local and long-distance travel needs.'
    },
];

export default testimonials;